import russianMessages from 'ra-language-russian';

export const customRussianMessages = {
  ...russianMessages,
  ra: {
    ...russianMessages.ra,
    navigation: {
      ...russianMessages.ra.navigation,
      no_results: 'Нет результатов',
    },
  },
  app: {
    merchantsShowNotifications: {
      accessSettingsDeletionError: 'Ошибка удаления настройки доступа',
      accessSettingsDeletedSuccessfully: 'Настройка доступа успешно удалена!',
      allAccessSettingsCreated: 'Все настройки доступа успешно созданы!',
      archiveCommissionErr1: 'Архивировать комиссию',
      archiveCommissionErr2:
        'невозможно, так как она связана с настройкой маршрутизации. Отключите настройки комиссии в настройках маршрутизации и повторите попытку заново.',
      permanentlyArchived1: 'Комиссия',
      permanentlyArchived2: 'будет переведена в архив без возможности повторного использования.',
      archiveCommission: 'Архивирование комиссии',
      afterFeeConfirmation1: 'После подтверждения комиссия',
      afterFeeConfirmation2:
        'будет отправлена на согласование ответственному финансовому менеджеру. Вы сможете редактировать или удалить комиссию только в случае её отклонения. Перед отправкой на согласование вы можете оставить комментарий.',
      sendFeeForApproval: 'Отправка комиссии на согласование',
      createCommissionRecalculation: 'Создать задание на перерасчёт комиссии по заказам?',
      notificationsGuide: {
        title: 'Справка по настройке уведомлений в системе',
        intro:
          'Система позволяет создавать и настраивать уведомления для мерчанта. Для настройки уведомлений выполните следующие шаги:',
        step1: 'Откройте форму "Создание настроек уведомления".',
        step2: 'Укажите ID чата Reddy, в которой должны отправляться уведомления.',
        step3: 'Определите события, по которым будут отправляться уведомления.',
        eventsInfo:
          'Перечень доступных событий может обновляться, добавляя новые варианты для настройки.',
        step4: 'Сохраните изменения.',
        backButton: 'Вернуться',
      },
      notificationTest: {
        title: 'Проверка работоспособности уведомлений:',
        step1: {
          before: 'Перейдите в форму ',
          action: '"Просмотр настроек уведомления"',
        },
        step2: {
          before: 'Выберите функцию ',
          action: '"Отправить тестовое сообщение"',
        },
        step3: 'Убедитесь, что уведомление поступило в указанный чат Reddy.',
        ifNotReceived: 'Если уведомление не пришло:',
        fix1: 'Проверьте корректность настроек и при необходимости измените их.',
        fix2: 'Если проблема не устраняется, обратитесь к администратору системы.',
        conclusion:
          'Этот процесс помогает обеспечить оперативное информирование мерчанта по важным событиям.',
      },
      testMessage: 'Тестовое сообщение',
      notificationSettingsView: 'Просмотр настроек уведомления',
      testMessageSent:
        'По указанным настройкам доступа было отправлено тестовое сообщение. Если тестовое сообщение не пришло по указанному каналу, то необходимо изменить настройки доступа и повторить отправку сообщения.',
      sendTestMessage: 'Отправка тестового сообщения',
      editNotificationSettings: 'Изменение настроек уведомления',
      enable: 'Включить',
      notificationWillBeTemporarily1: 'Уведомление',
      notificationWillBeTemporarily2: 'будет временно включено.',
      notificationWillBeTemporarily3: 'будет временно выключено.',
      enableNotificationSettings: 'Включение настроек уведомления',
      disableNotificationSettings: 'Выключение настроек уведомления',
      notificationSettingsDeletionMessage1: 'Настройки уведомления ',
      notificationSettingsDeletionMessage2: ' будут удалены без возможности восстановления.',
      notificationSettingsDeletionTitle: 'Удаление настроек уведомления',
      notificationSettingsCreation: 'Создание настроек уведомления',
      testNotificationSendingError: 'Ошибка отправки тестового уведомления',
      testNotificationSent: 'Тестовое уведомление отправлено успешно!',
      successfully: 'Успешно!',
      notificationSettingsDeleted: 'Настройка уведомлений успешно удалена!',
      notificationSettingsDeletionError: 'Ошибка удаления настройки уведомлений',
      notificationSettingsCreationError: 'Ошибка создания настройки уведомлений',
      notificationSettingsCreated: 'Настройка уведомлений успешно создана!',
      rejectionReasons: 'Причины отказа',
      orderConversions: 'Конверсии заказов',
      token: 'Токен',
      channelId: 'ID чата Reddy',
      notificationType: 'Тип уведомления',
      deliveryChannel: 'Канал доставки',
      deliveryAddress: 'Адрес доставки',
      notificationSettings: 'Настройки уведомлений',
      noNotificationSettings: 'Нет настроек для отправки уведомлений для мерчанта %{name}.',
      active: 'Активно',
    },
    merchantAccess: {
      reset: 'Очистить',
      firstName: 'Имя',
      lastName: 'Фамилия',
      assignmentDate: 'Дата назначения',
      noAccessAddedForMerchant: 'Мерчанту %{merchantName} не добавлены доступы',
      merchantAccessSettings: 'Настройка доступов мерчанта',
    },
    merchantCommissions: {
      autoCreateRefundAndChargeback: 'Автосоздать комиссии для Рефанда и Чарджбека',
      afterFeeApproval2:
        'будет переведена в статус «Внедрена» и начнет применяться при формировании «Заказов» с текущего момента.',
      activateCommissionError1: 'Активировать комиссию',
      activateCommissionError2:
        'невозможно, так как она не связана ни с одной настройкой маршрутизации. Обратитесь к администратору.',
      activateCommission: 'Внедрение комиссии',
      afterFeeApproval1: 'После подтверждения комиссия',
      afterFeeApproval3: 'станет доступна для настройки и использования в системе.',
      confirmFeeApproval: 'Подтвердить согласование комиссии?',
      feeReturned1: 'После отклонения комиссия',
      feeReturned2:
        'будет возвращена на доработку ответственному. Перед подтверждением отклонения вы можете оставить комментарий.',
      approvalRequestRejection: 'Отклонение запроса на согласование',
      noCommissionRecalculationTasks: 'Нет заданий на перерасчёт комиссии по заказам',
      clickToUpload: 'Нажмите, чтобы загрузить',
      orDragFile: 'или перетащите файл',
      createNewVersion: 'Создать новую версию',
      feeComments: 'Комментарии к комиссии',
      fieldsRequiredForGeneration: 'Для генерации надо заполнить поля',
      generateName: 'Сгенерировать название',
      reference: {
        title: 'Справка по настройке и работе с комиссиями',

        intro1:
          'В системе реализован процесс управления комиссиями, включающий их создание, настройку, согласование, внедрение и архивирование.',
        intro2: 'Комиссии могут быть:',

        types: {
          regular: 'обычными;',
          parent: 'родительскими;',
          child: 'дочерними;',
          ladder: 'комиссиями с лесенкой.',
        },

        description: {
          parent: {
            name: 'Родительская комиссия',
            text: 'не создается вручную: обычная комиссия становится родительской после создания на ее основе дочерней комиссии.',
          },
          child: {
            name: 'Дочерняя комиссия',
            text: 'создается как новая версия обычной или родительской комиссии.',
          },
          ladder: {
            name: 'Комиссия с лесенкой',
            text: 'используется для настройки ступенчатых условий комиссии; она не может быть родительской, и на ее основе нельзя создать дочернюю комиссию. В данной вкладке доступен только просмотр комиссий с лесенкой. Создание, настройка, согласование, внедрение и архивирование комиссий с лесенкой доступно в подразделе "Комиссии" только финансовым менеджерам.',
          },
        },

        intro3: 'Работа с комиссиями проходит через следующие статусы:',

        statuses: {
          new: {
            name: 'Новая',
            text: 'комиссия создана, но не отправлена на согласование;',
          },
          inApproval: {
            name: 'На согласовании',
            text: 'комиссия рассматривается ответственными лицами;',
          },
          rejected: {
            name: 'Отклонена',
            text: 'комиссия не одобрена;',
          },
          approved: {
            name: 'Согласована',
            text: 'комиссия одобрена и готова к внедрению;',
          },
          annulled: {
            name: 'Аннулирована',
            text: 'комиссия признана недействительной;',
          },
          activated: {
            name: 'Внедрена',
            text: 'комиссия успешно реализована;',
          },
          archived: {
            name: 'Архив',
            text: 'завершённая комиссия перемещена в архив.',
          },
        },
        roles: {
          paymentsManager: {
            title: 'Роль: Менеджер платежного отдела',
            intro1: 'Менеджер платежного отдела выполняет следующие действия с комиссиями:',
            intro2: {
              before: 'Если комиссия настраивается для',
              merchant: '"Мерчанта"',
              between: 'без признака',
              partner: '"Партнер"',
              after:
                'менеджер платежного отдела может выполнить весь процесс согласования самостоятельно, без участия финансового менеджера.',
            },
            intro3:
              'Менеджер платежного отдела выполняет следующие действия с заданиями на перерасчет комиссий:',

            actions: {
              create: {
                name: 'Создание комиссии',
                text: 'инициирует новую комиссию, добавляя необходимую информацию;',
              },
              submit: {
                name: 'Отправка на согласование',
                text: 'переводит комиссию в статус "На согласовании". При этом финансовому менеджеру отправляется уведомление о необходимости согласования комиссии;',
              },
              editRejected: {
                name: 'Изменение отклоненной комиссии',
                text: 'после отклонения комиссии финансовым менеджером, её можно отредактировать и повторно отправить на согласование;',
              },
              deleteRejected: {
                name: 'Удаление отклоненной комиссии',
                text: 'при необходимости отклоненную комиссию можно удалить;',
              },
              annul: {
                name: 'Аннулирование согласованной комиссии',
                text: 'переводит согласованную комиссию в статус "Аннулирована";',
              },
              activate: {
                name: 'Внедрение комиссии',
                text: 'для перевода комиссии в статус "Внедрена" необходимо настроить её в правилах маршрутизации исполнения заказов в платёжном агрегаторе. После выполнения настройки комиссия переводится в статус "Внедрена". Дочерняя комиссия может внедряться через действие "Внедрить" при выполнении условий;',
              },
              archive: {
                name: 'Перевод комиссии в архив',
                text: 'завершает работу с комиссией, перемещая её в архив.',
              },
            },

            recalculationActions: {
              create: 'Создание задания на перерасчет в дочерней комиссии;',
              view: 'Просмотр задания на перерасчет в дочерней комиссии;',
              edit: 'Редактирование задания на перерасчет в дочерней комиссии;',
              delete: 'Удаление задания на перерасчет в дочерней комиссии.',
            },
          },
          financeManager: {
            title: 'Роль: Менеджер финансового отдела',
            intro1:
              'Менеджер финансового отдела участвует в процессе согласования комиссий, созданных менеджерами платежного отдела:',
            intro2: 'Также менеджер финансового отдела выполняет следующие действия с комиссиями:',
            intro3:
              'Менеджер финансового отдела выполняет следующие действия с заданиями на перерасчет комиссий:',
            intro4:
              'При запуске задания на перерасчет система пересчитывает значения комиссий по заказам за указанный период. Если запуск выполняется для согласованной дочерней комиссии, которая связана с ранее внедренной родственной комиссией, дочерняя комиссия автоматически внедряется и начинает использоваться при создании новых заказов.',

            actions: {
              approve: {
                name: 'Согласование комиссии',
                text: 'одобряет комиссию, переводя ее в статус "Согласована";',
              },
              reject: {
                name: 'Отклонение комиссии',
                text: 'отклоняет комиссию, переводя ее в статус "Отклонена". При этом платежному менеджеру отправляется уведомление о необходимости внести изменения или удалить комиссию.',
              },
            },

            extraActions: {
              create: 'Создание комиссии;',
              approve: 'Отправка на согласование;',
              editReject: 'Изменение отклоненной комиссии;',
              deleteReject: 'Удаление отклоненной комиссии;',
              annulApproved: 'Аннулирование согласованной комиссии;',
            },

            extraActionsWithDefenition: {
              activate: {
                name: 'Внедрение комиссии',
                text: 'менеджер финансового отдела может внедрить только дочернюю комиссию;',
              },
              archive: {
                name: 'Автоматический перевод комиссии в архив',
                text: 'при внедрении финансовым менеджером новой дочерней комиссии, ранее внедренная родственная комиссия автоматически переводится системой в статус "Архив".',
              },
            },

            recalculationActions: {
              create: 'Создание задания на перерасчет в дочерней комиссии;',
              view: 'Просмотр задания на перерасчет в дочерней комиссии;',
              edit: 'Редактирование задания на перерасчет в дочерней комиссии;',
              delete: 'Удаление задания на перерасчет в дочерней комиссии.',
              run: 'Запуск задания на перерасчет в дочерней комиссии.',
            },
          },
        },
        actions: {
          back: 'Вернуться',
        },
      },
      feeEditing: 'Редактирование комиссии',
      itemUpdated: 'Элемент обновлен',
      feeDeletion: 'Удаление комиссии',
      feeWillBeDeleted: 'Комиссия %{name} будет удалена без возможности восстановления.',
      newFeeVersionCreation: 'Создание новой версии комиссии',
      createAlert3: 'Новая версия комиссии',
      createAlert4:
        'успешно создана. Вы можете отправить изменения на согласование или вернуться к списку комиссий для дальнейшей работы.',
      createAndApprove: 'Создать и согласовать',
      newFeeCreation: 'Создание новой комиссии',
      createAlert1: 'Новая комиссия',
      createAlert2:
        'успешно создана. Вы можете отправить её на согласование или вернуться к списку комиссий для дальнейшей работы.',
      view: 'Перейти к просмотру',
      backToList: 'Вернуться в список',
      feeCreationSuccessful: 'Создание комиссии успешно выполнено',
      feeConditions: 'Условия комиссии',
      activePeriodSettings:
        'Настройки периода активности определяют даты начала и окончания срока действия комиссии. Если дата окончания заранее неизвестна, она указывается по факту завершения срока действия при создании новой версии.',
      additionalSettings: 'Дополнительные настройки',
      basicSettings: 'Основные настройки',
      fix: 'Фикс.',
      max: 'Макс.',
      min: 'Мин.',
      activePeriod: 'Период активности',
      child: 'Дочерняя',
      type: 'Тип комиссии',
      parentFeeId: 'ID родительской комиссии',
      feeId: 'ID комиссии',
      noFeesForAvailable: 'Нет созданных "Комиссий" для доступных "Мерчантов" и "Провайдеров"',
      emptyMerchantAccess:
        'Для пользователя %{firstName} %{lastName} нет доступных мерчантов, обратитесь к администратору системы для настроек доступа.',
      emptyProviderAccount:
        'Для пользователя %{firstName} %{lastName} отсутствует доступ к настройкам "Комиссий", обратитесь к руководителю вашей рабочей группы для предоставления доступа.',
      feesList: 'Список комиссий',
      commissionCancelDialog: {
        title: 'Аннулирование комиссии',
        message1: 'Комиссия',
        message2: 'будет расформирована и аннулирована без возможности повторного согласования.',
        message3: 'Перед подтверждением аннулирования вы можете оставить комментарий.',
      },
      feeCreateSuccessDialog: {
        title: 'Создание комиссии успешно выполнено',
        newFee: 'Новая комиссия',
        created:
          'успешно создана. Вы можете отправить ее на согласование или вернуться ко списку комиссий для дальнейшей работы.',
        createdApproved:
          'успешно создана в статусе “Согласована”. Данную комиссию нельзя редактировать, но, при необходимости, вы можете её аннулировать.',
      },
    },
    limits: {
      gatewayCurrencyLimit1: 'Лимит в валюте %{currencyName} для шлюза',
      gatewayCurrencyLimit2: 'будет удален без возможности восстановления.',
      limitUpdatedSuccess: 'Лимит успешно отредактирован!',
      editLimit: 'Редактирование лимита',
      presetsHint: 'Укажите список пресетов через пробел.',
      deleteLimit: 'Удаление лимита',
      createLimit: 'Создание лимита',
      formInvalid: 'Форма заполнена неверно, проверьте, пожалуйста, ошибки',
      limitCreatedSuccess: 'Лимит успешно создан!',
      limitDeletedSuccess: 'Лимит успешно удален!',
      show: {
        title: 'Просмотр лимита',
      },
      limits: 'Лимиты',

      gateway: 'Шлюз',
      currency: 'Валюта',

      minDepositAmount: 'Мин. сумма пополнения',
      maxDepositAmount: 'Макс. сумма пополнения',
      minWithdrawalAmount: 'Мин. сумма вывода',
      maxWithdrawalAmount: 'Макс. сумма вывода',

      depositAmountPresets: 'Пресеты суммы пополнения',
      withdrawalAmountPresets: 'Пресеты суммы вывода',

      createdAt: 'Дата создания',
      updatedAt: 'Дата редактир.',

      merchantHasNoLimits: 'Мерчанту %{merchantName} не добавлены лимиты.',
    },
    provider: {
      providerView: 'Просмотр провайдера',
    },
    orderAdjustmentsReference: {
      title: 'Информационная справка',
      subtitle: 'Типы корректировок заказов',

      intro1:
        'Кнопка **«Настройки корректировки»** доступна, если выбран хотя бы один заказ, и для всех выбранных заказов существует хотя бы один общий доступный тип корректировки. Если такого типа нет, выбранные заказы нельзя скорректировать в рамках одной операции, поэтому кнопка недоступна.',
      intro2:
        'В форме **«Настройка корректировки заказов»** доступны только типы корректировки, применимые ко всем выбранным заказам.',

      type1Title: '1. Корректировка суммы заказа',
      type1Description:
        'Применяется к заказам со статусом **«Успех»** и с направлением **«Пополнение»** и **«Вывод»**.',
      result: 'Результат:',
      type1Result1: 'Изменение суммы заказа (увеличение или уменьшение).',
      type1Result2: 'Обновлённая сумма отражается на **счёте мерчанта**.',
      type1Result3:
        'Дополнительно (в зависимости от настройки **«Изменение баланса клиента»**) корректировка может затронуть баланс игрока.',

      type2Title: '2. Провести со статусом «Успех»',
      type2Description:
        'Применяется к заказам со статусами **«Ожидание»**, **«Провал»**, **«Просрочен»** и с направлением **«Пополнение»** и **«Вывод»**.',
      type2Result1: 'Изменение статуса заказа на **«Успех»**.',
      type2Result2: 'Сумма заказа зачисляется на счёт мерчанта.',
      type2Result3: 'Дополнительно (в зависимости от настроек) может влиять на баланс игрока.',

      type3Title: '3. Провести со статусом «Рефанд»',
      type3Description:
        'Применяется к заказам со статусом **«Успех»** и с направлением **«Пополнение»**.',
      type3Result1: 'Изменение статуса заказа на **«Рефанд»**.',
      type3Result2: 'Сумма заказа списывается со счёта мерчанта.',
      type3Result3: 'Дополнительно (в зависимости от настроек) может корректировать баланс игрока.',

      type4Title: '4. Провести со статусом «Чарджбек»',
      type4Description:
        'Применяется к заказам со статусом **«Успех»** и с направлением **«Пополнение»**.',
      type4Result1: 'Изменение статуса заказа на **«Чарджбек»**.',
      type4Result2: 'Сумма заказа списывается со счёта мерчанта.',
      type4Result3: 'Дополнительно (в зависимости от настроек) может корректировать баланс игрока.',

      type5Title: '5. Провести со статусом «Провал»',
      type5Description:
        'Применяется к заказам со статусами **«Подготовлен»**, **«Ожидание»**, **«Успех»** и с направлением **«Пополнение»** и **«Вывод»**.',
      type5Result1: 'Изменение статуса заказа на **«Провал»**.',
      type5Result2:
        'Для заказов со статусом **«Успех»** сумма заказа списывается со счёта мерчанта.',
      type5Result3: 'Для заказов со статусом **«Ожидание»** заказ отменяется без списания суммы.',
      type5Result4: 'Дополнительно (в зависимости от настроек) может корректировать баланс игрока.',

      type6Title: '6. Провести со статусом «Отмена»',
      type6Description:
        'Применяется к заказам со статусом **«Создан»** и с направлением **«Пополнение»** и **«Вывод»**.',
      type6Result1: 'Изменение статуса заказа на **«Отмена»**.',
      type6Result2: 'Заказ отменяется без списания суммы.',

      back: 'Вернуться',
    },
    gateway: {
      supportedCurrencies: 'Поддерживаемые валюты',
      defaultCurrency: 'Валюта по умолчанию',
      deactivationReason: 'Причина деактивации',
      gatewayView: 'Просмотр шлюза',
      orderExpirationTimeSec: 'Срок действия заказа (сек)',
      saveCustomerMethodData: 'Сохранить данные метода',
      statusRequestEnabled: 'Опрос статуса заказа',
      transactionRequestMaxAttempts: 'Макс. кол-во попыток опроса',
      statusPollingInterval: 'Интервал опроса статуса',
      externalAlias: 'Внешний алиас',
    },
    merchantAccounts: {
      accessEditing: 'Редактирование доступа',
      accessEnable: 'Включение доступа',
      subagentId: 'ID субагента',
      active: 'Активен',
      activityUpdatedSuccessfully: 'Активность успешно изменена.',
      currency: 'Валюта',
      enableAccountAccess: 'Включение доступа к счету',
      generateAccountNameHint:
        'Вы можете сгенерировать название счета после заполнения полей: провайдер и валюта',
      yes: 'Да',
      updated: 'Дата редактир.',
      lastUpdated: 'Последняя активность',
      created: 'Дата создания',
      add: 'Добавить',
      accountAccessWithParams: 'Доступ к счету {json}',
      useMerchantIdForProviderOrdersHint:
        'Если включено - заказы, создаваемые на стороне провайдера, будут создаваться с использованием идентификатора мерчанта',
      close: 'Закрыть',
      useGlobalIdCreate: 'Использовать сквозной ID',
      useGlobalIdView: 'Сквозной ID',
      view: 'К просмотру',
      merchant: 'Мерчант',
      noAccountsForMerchant: 'Мерчанту %{merchantName} не добавлены счета.',
      disableBankOperationsHint:
        'Может устанавливаться в настройках любого "Мерчанта" (не только с признаком "Партнерский"). Если включено - создать и отредактировать "Банковскую операцию" с данным счетом невозможно',
      name: 'Название',
      noAccess: 'НЕТ ДОСТУПА',
      cancel: 'Отменить',
      reset: 'Очистить',
      partner: 'Партнерский',
      show: 'Показать',
      provider: 'Провайдер',
      merchantAccountDetails: 'Просмотр счета',
      editAccountAccess: 'Редактирование доступа к счету',
      editMerchantAccount: 'Редактирование счёта',
      edit: 'Редактировать',
      accountAccessEditorWithParams: 'Редактор доступа к счёту {json}',
      merchantAccessCredentials: 'Реквизиты доступа к мерчанту',
      merchantAccessCredentialsWithParams: 'Реквизиты доступа к мерчанту {json}',
      generateName: 'Сгенерировать название',
      globalId: 'Сквозной ID',
      createAccount: 'Создание счёта',
      create: 'Создать',
      save: 'Сохранить',
      merchantAccountsList: 'Список счетов мерчанта',
      merchantAccountUpdatedSuccessfully: 'Счет мерчанта успешно отредактирован!',
      merchantAccountCreatedSuccessfully: 'Счет мерчанта успешно создан!',
      merchantAccountDeletedSuccessfully: 'Счет мерчанта успешно удален!',
      deleteAccount: 'Удаление счета',
      gateway: 'Шлюз',
      gateways: 'Шлюзы',
      accountDelete1: 'Счет',
      accountDelete2: 'будет удален без возможности восстановления.',
      accountDeleteError: 'Не удалось удалить счет мерчанта',
    },
    merchants: {
      allAccessSettings: 'Все настройки доступа успешно созданы!',
      afterAccessSettingsConfirmation:
        'После подтверждения включения доступа к настройкам, запись %{recordName} будет доступна к редактированию для выбранного пользователя. Ограничение доступа будет отключено автоматически в соответствии с указанным сроком окончания доступа.',
      addAccess: 'Добавить доступ',
      accessExpirationDate: 'Срок окончания доступа',
      responsiblePerson: 'Ответственный',
      ruleWillBeDelete: 'Правило %{name} будет удалено без возможности восстановления',
      deleteRule: 'Удаление правила',
      rulesHaveNotBeen: 'Мерчанту %{merchantName} не добавлены правила.',
      rulesOfMerchant: 'Список правил мерчанта',
      activeStatus: 'Активна',
      accounts: 'Счета (%{total})',
      providerSettingsTotal: 'Настройки провайдеров (%{total})',
      providerSettings: 'Настройки провайдеров',
      providerSettingsCreate: 'Добавление настроек провайдера',
      providerSettingsEdit: 'Изменение настроек провайдера',
      providerSettingsAlert: 'У мерчанта %{name} нет связанных провайдеров',
      providerSettingsSuccess: 'Настройки провайдера успешно созданы',
      providerSettingsSuccessEdit: 'Настройки провайдера успешно изменены',
      limits: 'Лимиты (%{total})',
      commissions: 'Комиссии (%{total})',
      rules: 'Правила (%{total})',
      notification: 'Уведомления (%{total})',
      accesses: 'Доступы (%{total})',
      merchantManagement: 'Управление мерчантом',
      merchantRestoried: 'Мерчант %{name} восстановлен',
      restoreMerchant: 'Восстановление мерчанта',
      merchantWillBeActivated1: 'Мерчант',
      merchantWillBeActivated2:
        'будет переведен в активное состояние, после станет доступен для настроек в системе и формированию финансовой отчётности.',
      toPassApiKeyValue: 'для передачи значения ключа API',
      useInternalService: 'Используйте внутренний сервис',
      merchants: 'Мерчанты',
      kuberaClientAccount: 'Учетная запись клиента сервиса Kubera',
      noMerchantsAvailableForUser:
        'Для пользователя %{firstName} %{lastName} нет доступных мерчантов, обратитесь к администратору системы настроек доступа',
      merchantWillBeDeletedPermanently1: 'После удаления мерчант',
      merchantWillBeDeletedPermanently2: 'будет недоступен для восстановления.',
      merchantDeletion: 'Удаление мерчанта',
      backToMerchantsList: 'Вернуться к списку мерчантов',
      name: 'Название',
      alias: 'Алиас',
      state: 'Состояние',
      company: 'Компании',
      referrals: 'Рефералы',
      notificationKey: 'Ключ нотификации',
      notificationLanguage: 'Язык уведомлений',
      channelIdFor: 'ID канала для',
      notificationsMismatch: 'missMatch уведомлений',
      partner: 'Партнерский',
      platform: 'Платформа',
      createdAt: 'Дата создания',
      updatedAt: 'Дата редактир.',
    },
    orderAdjustmentsReport: {
      adjustmentRequestCreatedSuccessfully: 'Запрос на корректировку успешно создан',
      dialog: {
        exportTitle: 'Экспорт отчёта',
      },
      notify: {
        exportStarted: 'Файл экспорта отчёта по корректировкам заказов формируется %{emailPart}',
        sentToEmail: ' и будет отправлен вам на почту',
      },
      filters: {
        time: 'Время',
        createdAtPeriod: 'Время создания / период',
        adjustmentType: 'Типы операций',
        impactToBalance: 'Движение по балансу',
        adjustmentStatus: 'Статусы операций',
        user: 'Авторы / Инициаторы',
        requestId: 'ID заявки',
      },
      searchDialogTitle: 'Поиск связанных корректировок по заказу',
      searchDialogText: 'Выполнить поиск связанных операций для заказа %{id}?',
      cancel: 'Отменить',
      confirm: 'Подтвердить',
      commentDialogTitle: 'Комментарий к операции %{id}',
      returnToList: 'Вернуться к списку',
      searchLinks: 'Поиск связей',
      viewComment: 'Посмотреть комментарий',
      author: 'Автор',
      createdAt: 'Дата создания',
      appliedAt: 'Дата проведения',
      method: 'Метод',
      merchant: 'Мерчант',
      provider: 'Провайдер',
      client: 'Клиент',
      orderStatusChange: 'Изменение статуса заказа',
      gateway: 'Шлюз',
      adjustmentDeclineReason: 'Причина отклонения корректировки',
      orderDirection: 'Направление заказа',
      amount: 'Сумма',
      adjustmentStatus: 'Статус корректировки',
      clientBalanceChange: 'Изменение баланса клиента',
      hasBalanceActivity: 'Есть движение по балансу',
      noBalanceActivity: 'Нет движения по балансу',
      adjustmentType: 'Тип корректировки',
      title: 'Отчёт по корректировкам заказов',
      reset: 'Очистить',
      infoAlertTitle: 'Отчёт по корректировкам',
      infoAlertPart1: 'Для получения данных отчёта по корректировкам заказов воспользуйтесь формой',
      filter: 'Фильтр',
      infoAlertPart2: 'или',
      searchById: 'Поиск по ID',
      infoAlertPart3:
        'Если требуется список корректировок по конкретной заявке, вы можете использовать данные из системных уведомлений или корпоративного мессенджера Reddy.',
      orderId: 'ID заказа',
      rejectReason: 'Причина отмены',
      orderAmount: 'Сумма заказа',
      amountChange: 'Изменение суммы заказа',
      orderStatus: 'Статус заказа',
      statusChange: 'Изменение статуса заказа',
      clientId: 'ID клиента',
      direction: 'Направление',
    },
    orderAdjustments: {
      excludeDialog: {
        title: 'Исключить заказ из корректировки',
        messageStart: 'Заказ',
        messageMiddle: 'со статусом',
        messageEnd: 'будет исключен из корректировки.',
        cancel: 'Отменить',
        confirm: 'Подтвердить',
      },
      excludeGroupDialog: {
        title: 'Исключить группу заказов из корректировки',
        message: 'Из списка корректировки будет исключено %{selectedOrdersAmount} заказов.',
        cancel: 'Отменить',
        confirm: 'Подтвердить',
      },
      resetDialog: {
        title: 'Сбросить результаты предпросмотра',
        message: 'После подтверждения, настройки поиска и список найденных ID будут сброшены.',
        cancel: 'Отменить',
        confirm: 'Подтвердить',
      },
      submitDialog: {
        title: 'Отправить корректировку по заказам',
        message: 'После подтверждения, данные корректировок будут переданы в обработку.',
        cancel: 'Отменить',
        confirm: 'Подтвердить',
      },
      successDialog: {
        title: 'Данные по корректировке успешно отправлены',
        message:
          'По завершению процесса корректировки заказов, вам будет отправлены уведомления в панели администрирования и Reddy с результатами обработки данных.',
        close: 'Закрыть',
        goToReport: 'Перейти к отчёту корректировок',
      },
      bulkActions: {
        comment: 'комментарий',
        exclude: 'исключить',
      },
      contextMenu: {
        editAmount: 'Редактировать сумму',
        comment: 'Комментарий',
        exclude: 'Исключить',
      },
      adjustmentOrderAmount: 'Корректировка суммы заказа',
      adjustmentStatusToSuccess: 'Провести со статусом "Успех"',
      adjustmentStatusToRefund: 'Провести со статусом "Рефанд"',
      adjustmentStatusToChargeback: 'Провести со статусом "Чарджбек"',
      adjustmentStatusToFailure: 'Провести со статусом "Провал"',
      adjustmentStatusToCancelled: 'Провести со статусом "Отмена"',
      allowedStatusSuccess: 'Доступно при заказах в статусе "Успех"',
      allowedStatusPendingFailedExpired:
        'Доступно при заказах в статусах "Ожидание", "Провал" и "Просрочен"',
      allowedStatusPreparedSuccessPending:
        'Доступно при заказах в статусах "Подготовлен", "Успех" и "Ожидание"',
      allowedStatusCreated: 'Доступно при заказах в статусе "Создан"',
      adjustmentType: 'Тип корректировки',
      required: 'Обязательно для заполнения',
      adjustmentTypeMessages: {
        orderAmount:
          'Данная корректировка доступна для заказов со статусом "Успех", для которых после отправки будет изменена сумма транзакции.',
        statusToSuccess:
          'Данная корректировка доступна для заказов со статусом "Ожидание", "Провал" и "Просрочен", которые после отправки будут переведены в статус "Успех".',
        statusToRefund:
          'Данная корректировка доступна для заказов со статусом "Успех", которые после отправки будут переведены в статус "Рефанд".',
        statusToChargeback:
          'Данная корректировка доступна для заказов со статусом "Успех", которые после отправки будут переведены в статус "Чарджбек".',
        statusToFailure:
          'Данная корректировка доступна для заказов со статусом "Подготовлен", "Успех" и "Ожидание", которые после отправки будут переведены в статус "Провал".',
        statusToCanceled:
          'Данная корректировка доступна для заказов со статусом "Создан", которые после отправки будет переведены в статус "Отмена".',
      },
      impactToBalanceMessages: {
        true: 'По корректируемым заказам должно учитываться воздействие на баланс счета у игрока.',
        false:
          'По корректируемым заказам не будет учитываться воздействие на баланс счета у игрока.',
      },
      adjustmentDialogTitle: 'Настройка корректировки заказов',
      balanceMovementLabel: 'Движение по балансу',
      balanceMovementTrue: 'С движением средств по балансу "Игрока"',
      balanceMovementFalse: 'Без движения средств по балансу "Игрока"',
      submitButton: 'Отправить',
      cancelButton: 'Отменить',
      header: {
        filterById: 'Фильтр по ID',
        adjustmentSettings: 'Настройки корректировки',
        info: 'Дополнительная информация',
        submitSuccess: 'Данные по корректировке успешно отправлены',
        goToReport: 'Перейти к отчёту',
        submitInfo:
          'После завершения процесса корректировки заказов вы получите уведомления в панели администрирования и Reddy с результатами обработки.',
      },
      filters: {
        clear: 'Сбросить',
        apply: 'Применить',
        dialogTitle: 'Фильтрация по ID',
        addFilters: 'Укажите ID для поиска заказов',
        notFoundIds: 'Некоторые ID не найдены',
      },
      datagrid: {
        merchantId: 'Мерчант ID',
        created: 'Создан',
        amount: 'Сумма',
        orderOrTx: 'заказа / транзакции',
        direction: 'Направление',
        status: 'Статус',
        client: 'Клиент',
        merchant: 'Мерчант',
        provider: 'Провайдер',
        paymentSystem: 'платёжная система',
        gateway: 'Шлюз',
        method: 'Метод',
        comment: 'Комментарий',
        exclude: 'Исключить',
      },
      dialogs: {
        groupCommentDialog: {
          title: 'Комментарий для группы заказов',
          label: 'Комментарий',
          buttons: {
            reset: 'Сбросить',
            save: 'Сохранить',
            cancel: 'Отменить',
          },
        },
        commentDialog: {
          title: 'Комментарий к корректировке',
          label: 'Комментарий',
          buttons: {
            clear: 'Очистить',
            save: 'Сохранить',
            cancel: 'Отменить',
          },
        },
        comment: {
          title: 'Комментарий по заказу',
          submit: 'Сохранить',
        },
        groupComment: {
          title: 'Добавить комментарий группе заказов',
          submit: 'Сохранить',
        },
        amount: {
          title: 'Изменить сумму для заказа',
          submit: 'Сохранить',
          clear: 'Сбросить',
        },
        adjustment: {
          title: 'Настройки корректировки',
          submit: 'Продолжить',
        },
        submit: {
          title: 'Подтверждение корректировки',
          submit: 'Отправить',
        },
        success: {
          title: 'Корректировка успешно выполнена',
          ok: 'Готово',
        },
        reset: {
          title: 'Сбросить фильтры',
          submit: 'Сбросить',
        },
        reference: {
          title: 'Справочная информация',
        },
        exclude: {
          title: 'Исключить заказ',
          submit: 'Исключить',
        },
      },
    },
    adjustments: {
      massOrderAdjustment: 'Массовая корректировка заказов',
      searchById: 'Поиск по ID',
      preview: 'Предварительный просмотр',
      previewDescription:
        'Для предварительного просмотра, нужно выполнить поиск по одному или списку необходимых "Заказов". В случае, если необходимо сформировать список "Заказов" по более широким параметрам, то воспользуйтесь разделом "Заказы".',
    },
    common: {
      emailRequiredInProfile:
        'Для получения отчёта на почту необходимо указать email в настройках профиля. Обратитесь к администратору',
      serverError: 'Ошибка сервера',
      ru: 'Русский',
      en: 'Английский',
      updated: 'Обновлен',
      merchantAccount: 'Счет мерчанта',
      approved: 'Одобрен',
      yes: 'Да',
      no: 'Нет',
      error: 'Ошибка',
      createdAt: 'Дата создания',
      updatedAt: 'Дата применения',
      requestLogs: 'Логи запросов',
      notifications: 'Уведомления',
      generalInformation: 'Общая информация',
      idTransferredToTheProviderSide: 'ID передан на сторону Провайдера',
      noResults: 'Результатов не найдено',
      view: 'Просмотр',
      activityChanged: 'Активность успешно изменена',
      and: 'И',
      or: 'ИЛИ',
      info: 'Информация',
      files: 'Файлы',
      comments: 'Комментарии',
      of: 'из',
      loading: 'Загрузка...',
      fileDownloadFailure: 'Не удалось скачать файл',
      from: 'от',
      to: 'до',
      emptyMerchantAccessAlert:
        'Для пользователя %{firstName} %{lastName} отсутствует доступ к мерчантам, обратитесь к администратору системы для настроек доступа.',
    },
    table: {
      comment: 'Комментарий',
      actived: 'Активный',
      executionTime: 'Время исполнения',
      countryCode: 'Код страны',
      creationTime: 'Время создания',
      updateTime: 'Время обновления',
      createdAt: 'Дата создания',
      updatedAt: 'Дата редактир.',
      lastUpdatedAt: 'Дата редактир.',
      amount: 'Сумма',
      currency: 'Валюта',
      direction: 'Направление',
      method: 'Метод',
      status: 'Статус',
      merchant: 'Мерчант',
      client: 'Клиент',
      clientData: 'Данные клиента',
      provider: 'Провайдер',
      gateway: 'Шлюз',
      declineReason: 'Причина отклонения',
      name: 'Название',
      merchantsAmount: 'Кол-во мерчантов',
      entity: 'Сущность',
      entities: 'Сущности',
      entityId: 'ID сущности',
      user: 'Пользователь',
      ip: 'IP адрес',
      eventType: 'Тип события',
      email: 'Электронная почта',
      role: 'Роль',
      description: 'Описание',
      order: 'Порядок',
      sortOrder: 'Порядок сорт.',
      trafficPercentage: 'Процент трафика',
      active: 'Активен',
      account: 'Счет',
      commissions: 'Комиссии',
      lastActivity: 'Последняя активность',
      alias: 'Алиас',
      logo: 'Логотип',
      idKubera: 'Kubera ID',
      idMerchant: 'Мерчант ID',
      idProvider: 'Провайдер ID',
      badge: 'Бейдж метода',
    },
    buttons: {
      approved: 'Согласовать',
      approval: 'На согласование',
      activate: 'Внедрить',
      annul: 'Аннулировать',
      goTo: 'Перейти',
      info: 'Справка',
      loading: 'Загрузка',
      inArchive: 'В архив',
      restore: 'Восстановить',
      accessDenied: 'Нет доступа',
      showValue: 'Показать',
      archived: 'Архивировать',
      add: 'Добавить',
      approve: 'Подтвердить',
      reject: 'Отклонить',
      close: 'Закрыть',
      show: 'Просмотр',
      copy: 'Копировать',
      copied: 'Cкопировано',
      copyFailed: 'Копирование не удалось',
      export: 'Экспорт',
      saveFilter: 'Сохранить настройки фильтра',
      apply: 'Применить',
      reset: 'Очистить',
      cancel: 'Отменить',
      delete: 'Удалить',
      back: 'Назад',
      continue: 'Отправить',
      exportTo: 'Выгрузить в',
      searchById: 'Поиск по ID',
      filter: 'Фильтр',
      columns: 'Колонки',
      columnsSetupAvailable: 'Настройка колонок доступна',
      afterReportGenerated: 'после формирования отчёта',
      availableActions: 'Доступные действия',
      favorite: 'Мои фильтры',
      noSettings: 'Отсутствуют настройки',
      addFilterSettingsViaFilter: 'Добавьте настройки фильтра через “Фильтр”',
      userActions: 'Пользовательские действия',
      edit: 'Редактировать',
      save: 'Сохранить',
      confirm: 'Подтвердить',
      disable: 'Выключить',
      create: 'Создать',
      archive: 'Архивировать',
      unarchive: 'Разархивировать',
      view: 'Смотреть',
      collapse: 'Свернуть',
    },
    notification: {
      error: 'Ошибка',
      unknownError: 'Неизвестная ошибка',
    },
    filter: {
      ruleId: 'ID правила',
      defaultDateRange: 'Период по умолчанию',
      markAsFavourite: 'Отметить как избранное',
      partners: 'Партнерский',
      platform: 'Платформа',
      referrals: 'Рефералы',
      company: 'Компания',
      companies: 'Компании',
      state: 'Состояние',
      clearFilter: 'Очистить фильтр',
      creationTime: 'Время',
      enterId: 'Введите ID и нажмите Enter',
      enterOrderIds: 'Введите один или несколько ID заказов, нажимая Enter после каждого ID',
      searchById: 'Поиск по ID',
      idKubera: 'ID Kubera',
      idMerchant: 'ID Мерчантов',
      idProvider: 'ID Провайдеров',
      idAny: 'Любой ID',
      idNotFound: 'ID заказов не найдены в системе',
      filter: 'Фильтр',
      presetCreated: 'Настройка фильтра %{name} сохранена',
      presetDeleted: 'Настройка фильтра %{name} удалена',
      favorite: 'Мои фильтры',
      filterSettings: 'Настройка фильтра',
      willBeDeletedFromLocalStorage:
        'будет удалена из локального хранилища без возможности восстановления',
      deleteFilterSettings: 'Удалить настройки для фильтра?',
      fav: 'Избранное',
      creationTimePeriod: 'Время создания / период',
      anyOrderId: 'Любой ID',
      merchant: 'Мерчант',
      merchants: 'Мерчанты',
      provider: 'Провайдер',
      providers: 'Провайдеры',
      gateways: 'Шлюзы',
      methods: 'Методы',
      direction: 'Направление',
      status: 'Статус',
      statuses: 'Статусы',
      currency: 'Валюта',
      currencies: 'Валюты',
      conversionCurrency: 'Валюта конвертации',
      customer: 'Клиент',
      amountFrom: 'Сумма от',
      amountTo: 'Сумма до',
      declineReason: 'Причина отказа',
      matchRejectReason: 'Полное совпадение по причине отказа',
      appliedFilterTooBroad:
        'Применённый фильтр слишком широкий, поэтому показано только 1000 записей. Чтобы получить все результаты, сделайте экспорт',
      name: 'Название',
      period: 'Период от/до',
      dateRange: 'Дата / период от - до',
      entity: 'Сущность',
      entities: 'Сущности',
      entityId: 'ID сущности',
      role: 'Роль',
      roles: 'Роли',
      user: 'Пользователь',
      users: 'Пользователи',
      eventType: 'Тип события',
      eventTypes: 'Типы событий',
      active: 'Активен',
      method: 'Метод',
      clientId: 'Идентификатор клиента',
      country: 'Страна',
      countries: 'Страны',
      noMerchantsAvailableForUser:
        'Для пользователя %{firstName} %{lastName} нет доступных мерчантов, обратитесь к администратору системы для настроек доступа.',
      emptyList: 'Чтобы сформировать отчёт, выберите период и необходимые параметры в фильтре.',
      reportGeneratedForPeriod: 'Отчёт сформирован за период',
      gateway: 'Шлюз',
      category: 'Категория',
      categories: 'Категории',
      critical: 'Критичная',
      language: 'Язык',
      selectMerchantFirst: 'Сначала выберите мерчанта',
      selectProviderFirst: 'Сначала выберите провайдера',
    },
    validation: {
      onlyNumbers: 'Допустимы только числовые значения',
      onlyPositive: 'Значения должны быть положительными',
      maxItems: 'Максимум %{count} элементов',
      minGreaterThanMax: 'Значение "MIN" не может быть больше значения "MAX"',
      enterNumber: 'Введите число',
      required: 'Обязательно для заполнения',
      requiredField: 'Обязательное поле',
      maxPeriod1year: 'Максимальный период составляет 1 год.',
      maxPeriod31Days: 'Максимальный период для формирования виджетов - 31 день',
      wrongDomain: 'Некорректный домен',
      string: {
        maxLength: 'Это значение слишком длинное. Оно должно содержать %{max} символа или меньше.',
        minLength: 'Значение слишком короткое. Должно быть равно %{min} символам или больше.',
      },
      number: {
        isNumber: 'Должно быть числом',
        noNegative: 'Не должно быть отрицательным',
        integer: 'Должно быть целым',
        greaterThan: 'Должно быть больше %{min}',
        lessThan: 'Должно быть меньше %{max}',
      },
    },
    login: {
      numberReddy: 'Номер Reddy',
      password: 'Пароль',
      rememberMe: 'Запомнить меня',
      credentials: 'Вход в админ-панель Kubera',
      newPassword: 'Придумайте новый пароль',
      secondFactor: 'Двухфакторная авторизация',
      forgotPassword: 'Забыли пароль?',
      signIn: 'Войти',
      invalidNumberOrPassword: 'Неверный номер Reddy или пароль',
      codeFrom: 'Код из Reddy',
      requestNewCode: 'Запросить новый код',
      send: 'Отправить',
      codeResendUnavailable: 'Повторное получение кода невозможно, попробуйте позже',
      codeAttemptsExceeded:
        'Вами было превышено допустимое количество попыток ввода кода. Вы можете попробовать снова через 30 минут',
      passwordsDoNotMatch: 'Пароли не совпадают',
      newPass: 'Новый пароль',
      confirmPass: 'Повторите новый пароль',
    },
    statuses: {
      created: 'Создан',
      prepared: 'Подготовлен',
      pending: 'Ожидание',
      success: 'Успех',
      failure: 'Провал',
      cancelled: 'Отменен',
      expired: 'Просрочен',
      refund: 'Рефанд',
      chargeback: 'Чарджбек',
      waitingConfirmation: 'На проверке',
      active: 'Активен',
      archive: 'В архиве',
    },
    direction: {
      payment: 'Пополнение',
      payout: 'Вывод',
      all: 'Bсе направления',
    },
    orders: {
      ordersExportFileIs: 'Файл экспорта заказов формируется',
      ordersExportFileIsSend: 'и будет отправлен вам на почту',
      confirmGoToBulkOrders:
        'Подтвердите переход к разделу "Массовая корректировка заказов" для %{selectedIds} заказов.',
      goToOrdersAdjustment: 'Перейти к корректировке заказов',
      ordersAdjustment: 'Корректировка заказов',
      bulkResendNotifications: {
        button: 'Переотправить уведомления',
        confirmTitle: 'Переотправить уведомления?',
        confirmMessage:
          'По выбранным заказам будут повторно отправлены уведомления мерчанту. Заказы, по которым уведомление ранее не отправлялось, будут пропущены.',
        successMessage: 'Запрос на переотправку уведомлений принят в обработку',
      },
      logs: {
        requestType: 'Тип запроса:',
        eventId: 'ID события:',
        request: 'Запрос',
        response: 'Ответ',
        title: 'Логи запросов',
        empty: 'Логи запросов отсутствуют',
        createdAt: 'Время',
        statusChange: 'Изменение статуса:',
        direction: 'Направление запроса:',
      },
      notifications: {
        empty: 'Уведомления отсутствуют',
        title: 'Список уведомлений',
        tooltipText:
          'Вы можете переотправить уведомление. Тело запроса будет автоматически собрано по текущим значениям статуса и другим параметрам заказа.',
        id: 'ID',
        delivered: 'Доставлено',
        attempts: 'Число попыток',
        nextAttempt: 'Следующая попытка',
        send: 'Отправить',
        httpRequest: 'URL',
        requestBody: 'Тело запроса',
        response: 'Ответ',
        status: 'Статус',
        sendNotification: 'Отправить уведомление',
      },
      transactions: {
        history: 'История транзакций',
        noTransactions: 'Транзакции отсутствуют',
        transactionId: 'ID Транзакции',
        createdAt: 'Время создания',
        transactionType: 'Тип транзакции',
        transactionAmount: 'Сумма транзакции',
        currency: 'Валюта',
        commissionRule: 'Комиссионное правило',
        commissionAmountOrderCurrency: 'Сумма комиссии',
        commissionAmountRuleCurrency: 'Сумма комиссии',
        commissionOrderCurrency: 'в валюте заказа',
        commissionRuleCurrency: 'в валюте правила',
        noValue: 'Нет',
      },
      statuses: {
        history: 'История статусов',
        noStatuses: 'Статусы отсутствуют',
        statusId: 'ID статуса',
        orderStatus: 'Статус заказа',
        changedAt: 'Время изменения',
      },
      urls: {
        return: 'URL возврата',
        pending: 'URL в процессе',
        success: 'URL успеха',
        failure: 'URL провала',
        notification: 'URL уведомлений',
        resources: 'Ресурсы',
      },
      bulkResendNotificationsGuide: {
        title: 'Справка по работе с массовой переотправкой уведомлений',
        intro1:
          'Функция массовой переотправки уведомлений позволяет повторно отправить уведомления мерчантам сразу по нескольким выбранным заказам.',
        intro2:
          'Используйте массовую переотправку уведомлений, если требуется повторно передать информацию мерчанту по группе заказов.',
        stepsTitle: 'Чтобы выполнить массовую переотправку уведомлений:',
        step1: 'Выберите один или несколько заказов в общем списке.',
        step2: 'В панели массовых действий нажмите кнопку "Переотправить уведомления".',
        step3: 'Подтвердите действие в модальном окне.',
        afterConfirmation:
          'После подтверждения запрос будет принят в обработку. Переотправка выполняется в фоновом режиме, поэтому не нужно ждать завершения переотправки по каждому заказу.',
        limitTitle: 'Ограничение',
        limit:
          'За один раз можно переотправить уведомления не более чем по 100 заказам. Если требуется переотправить уведомления по большему количеству заказов, разделите список на несколько групп по 100 заказов или меньше.',
        scopeTitle: 'Какие заказы будут обработаны',
        scope:
          'Уведомление будет повторно отправлено только по тем заказам, по которым ранее уже отправлялось уведомление мерчанту. Если по выбранному заказу ранее не было отправленного уведомления, такой заказ будет пропущен. Это не считается ошибкой и не блокирует переотправку уведомлений по остальным выбранным заказам.',
        availabilityTitle: 'Доступность',
        availability:
          'Массовая переотправка уведомлений доступна пользователям с ролями "Админ" и "Менеджер платежного отдела".',
        closeButton: 'Закрыть',
      },
      orderAdjustment: 'Корректировка заказа',
      amountAdjustment: 'Корректир. суммы',
      providerDetails: 'Данные провайдера',
      orderNum: 'Заказ #%{originId}',
      merchantDetails: 'Данные мерчанта',
      theOrderIsRejected: 'Заказ отклонен',
      testModeWarning5:
        'Заказ #%{originId} отклонён. Вы можете перейти к настройкам шлюза %{gatewayName} чтобы изменить их.',
      theOrderIsApproved: 'Заказ подтверждён',
      testModeWarning4:
        'Заказ #%{originId} успешно подтверждён. Вы можете перейти к настройкам шлюза %{gatewayName} чтобы перевести его в стандартный режим работы.',
      proceedToTheGatewaySettings: 'Перейти к настройкам шлюза',
      orderRejection: 'Отклонение заказа',
      testModeWarning3:
        'Заказ #%{originId} был создан через шлюз %{gatewayName}, работающий в тестовом режиме. Отклонение заказа должно выполняться после его полной проверки, по итогам которой были найдены ошибки.',
      orderApproval: 'Подтверждение заказа',
      testModeWarning2:
        'Заказ #%{originId} был создан через шлюз %{gatewayName}, работающий в тестовом режиме. Подтверждение заказа должно выполняться после его полной и успешной проверки.',
      testModeWarning:
        'Заказ #%{originId} был создан через шлюз %{gatewayName}, который работает в тестовом режиме. Необходимо выполнить проверку заказа и подтвердить или отклонить его.',
      orderReview: 'Проверка заказа',
      failedToRejectTheOrder: 'Не удалось отклонить заказ',
      failedToApproveTheOrder: 'Не удалось подтвердить заказ',
      theOrderHasBeenRejectedSuccessfully: 'Заказ успешно отклонен',
      theOrderApprovedSuccessfully: 'Заказ успешно подтвержден',
      commentOper: 'Комментарий к операции #%{originId}',
      initiatorAuthor: 'Инициатор / Автор',
      statusChange: 'Изменение статуса',
      amountChange: 'Изменение суммы',
      adjustmentStatus: 'Статус корректировки',
      playerBalanceTransactions: 'Движение по балансу игрока',
      adjustmentType: 'Тип корректировки',
      adjustmentId: 'ID корректировки',
      orderAdjustments: 'Корректировки заказа',
      noOrderAdjustments: 'Корректировки заказа отсутствуют',
      addInfo: 'Дополнительные данные',
      info: 'Информация',
      orderDetails: 'Просмотр заказа',
      ordersRegisteredInStatuses:
        'За период отчёта %{reportPeriod} по направлению "%{direction}" в системе зарегистрированы заказы в следующих статусах:',
      copySummary: 'Копировать сводку',
      notCompleted: 'Не исполнено',
      completed: 'Исполнено',
      total: 'Итого',
      ordersSummaryForPeriod: 'Сводка по заказам за период',
      summaryForPeriod: 'Сводка за период',
      reportGeneratedForPeriod: 'Отчёт сформирован за период',
      orders: 'Заказы',
      exportReport: 'Экспорт отчёта',
      toGenerateReportSelect:
        'Чтобы сформировать отчёт, выберите сохраненный вариант из списка “Мои фильтры” или задайте новые параметры в фильтре',
      reportWillBeConverted:
        'После подтверждения, отчёт будет конвертирован в формат %{exportType} и доступен в "Мои загрузки".',
      duplicateEmailSending: 'Дублировать отправку на почту',
      summary: {
        created: 'Создан',
        prepared: 'Подготовлен',
        pending: 'Ожидание',
        success: 'Успех',
        failure: 'Провал',
        cancelled: 'Отменен',
        refund: 'Рефанд',
        chargeback: 'Чарджбек',
        expired: 'Просрочен',
        waitingConfirmation: 'На проверке',
        executedOrderCount: 'Исполненные',
        notExecutedOrderCount: 'Не исполненные',
        noValue: 'значение отсутствует',
        total: 'Итого',
        period: 'Период',
      },
    },
    restorePassword: {
      setReddyNumber: 'Укажите номер Reddy для восстановления пароля',
      notFoundByNumber: 'Пользователь с таким номером Reddy не найден',
    },
    companies: {
      titleText: 'Компании',
      tooltipText: 'Юридическое лицо, к которому принадлежит мерчант.',
      activeStatus: 'Активна',
      details: 'Просмотр компании',
      editTitle: 'Редактирование компании',
      createTitle: 'Создание компании',
      deleteTitle: 'Удаление компании',
      deleteDetails1: 'После удаления компания',
      deleteDetails2: 'будет недоступна для восстановления.',
      returnToList: 'Вернуться к списку компаний',
      companyUnarchive: 'Компания %{name} восстановлена',
      companyActivated1: 'Компания',
      companyActivated2:
        'будет переведена в активное состояние и станет доступна для настроек в системе и формирования финансовой отчётности.',
      companyUnarchiveTitle: 'Восстановление компании',
      companyArchiveTitle: 'Архивирование компании',
      companyArchiveDetails1: 'Компания',
      companyArchiveDetails2:
        'будет переведена в архив и перестанет быть доступной для настроек в системе и формирования финансовой отчётности. При необходимости, функциональность данной компании может быть восстановлена.',
    },
    userActions: {
      titleText: 'Пользовательские действия',
      details: 'Просмотр действия',
      jsonSchema: 'Json схема события',
    },
    commissions: {
      details: 'Просмотр комиссии',
      conditions: 'Условия комиссии',
      recalculationTasks: 'Задания на перерасчёт комиссии',
      type: 'Тип комиссии',
      relatedCommissions: 'Связанные комиссии',
      activityPeriodFrom: 'Период активности от',
      activityPeriodTo: 'Период активности до',
      transactionTypes: 'Типы транзакций',
      zeroed: 'Нулевая комиссия',
      percent: 'Процент',
      fixed: 'Фиксированная',
      max: 'Максимальная',
      min: 'Минимальная',
      calculationMethod: 'Способ расчёта',
      noFiles: 'Файлы отсутствуют',
      noComments: 'Комментарии отсутствуют',
    },
    commissionsRecalculation: {
      createDialog: {
        title: 'Создать задание на перерасчёт комиссии',
        message:
          'Укажите настройки часового пояса, даты и времени на основании которых после согласования комиссии будет запущен перерасчёт комиссий по заказам.',
        date: 'Период перерасчета от - до',
        error: 'Ошибка при создании',
      },
      successDialog: {
        title: 'Задание успешно создано',
        message:
          'После завершения процесса согласования комиссии, для финансового менеджера будет доступна опция запуска перерасчёта значений комиссий по заказам по указанным настройкам',
        show: 'Просмотр задания',
      },
      showDialog: {
        title: 'Задание на перерасчёт комиссии',
        period: 'Период перерасчёта (от - до)',
        days: 'Количество календарных дней',
        amount: 'Количество заказов к перерасчёту',
      },
      deleteDialog: {
        title: 'Удалить задание на перерасчёт комиссии',
        message:
          'После подтверждения удаления, данное задание будет недоступно для восстановления.',
      },
    },
    merchantAccount: {
      details: 'Просмотр счета',
      partners: 'Партнерский',
      merchantIdEnabled: 'Использовать сквозной ID',
      credentials: 'Доступ к счету {json}',
    },
    gatewayRules: {
      titleText: 'Правила',
      noRulesAlert:
        'Для пользователя %{firstName} %{lastName} нет доступных правил, обратитесь к администратору системы настроек доступа',
      trafficPercentage: 'Процент трафика',
      condition: 'Условие',
      expression: 'Выражение',
      mappings: 'Маппинги',
      rules: 'Правила',
      conditionTooltipText: 'Для изменения условия перейдите на страницу редактирования правила',
      mappingTooltipText:
        'При просмотре доступно только изменение процентов траффика. Для изменения остальных характеристик маппинга перейдите на страницу редактирования правила',
      activityChangeSuccess: 'Активность правила успешно изменена',
      activityChangeError: 'Ошибка изменения активности правила',
      ruleIsActive: 'Правило активно',
      ruleIsInactive: 'Правило не активно',
      enableRule: 'Включение правила',
      disableRule: 'Выключение правила',
      enableMethod: 'Включение метода',
      disableMethod: 'Выключение метода',
      enableMethodMessage:
        'Метод %{methodName} для правила %{gatewayRuleName} после подтверждения активации будет работать в соответствии с текущими настройками.',
      disableMethodMessage: 'Метод %{methodName} для правила %{gatewayRuleName} будет выключен.',
      enableRuleMessage:
        'Правило %{name} после подтверждения активации будет работать в соответствии с текущими настройками',
      disableRuleMessage: 'Правило %{name} будет временно выключено.',
      methodMerchantsName: 'Название метода для мерчанта',
      mappingIsActive: 'Маппинг активен',
      mappingIsInactive: 'Маппинг не активен',
      mappingDetails: 'Просмотр описания маппинга',
      mappingEdit: 'Редактирование описания маппинга',
      trafficChangeSuccess: 'Процент трафика успешно изменен',
      trafficChange: 'Изменение процента трафика',
      trafficRule:
        '0 — шлюз будет отключен.\nВ иных случаях трафик будет распределяться пропорционально к сумме всех значений процента трафика.',
      ruleDeleted: 'Правило успешно удалено',
      deleteRule: 'Удалить правило',
      deleteMapping: 'Удалить маппинг',
      ruleDeleteWarning:
        'Правило ID:%{id} для мерчанта %{merchantName} будет удалено без возможности восстановления.',
      addGateway: 'Добавить шлюз',
      deleteGateway: 'Удалить шлюз',
      deleteExpression: 'Удалить выражение',
      deleteGroup: 'Удалить группу',
      deleteCondition: 'Удалить условие',
      group: 'Группу',
      goToOrders: 'Перейти к заказам',
      ruleDetails: 'Просмотр правила',
      editRule: 'Редактирование правила',
      createRule: 'Создание правила',
      editRuleBtn: 'Редактировать правило',
      deleteRuleBtn: 'Удалить правило',
      createRuleBtn: 'Создать правило',
      ruleEdited: 'Правило отредактировано',
      saveRule: 'Сохранить правило',
      ruleCreated: 'Правило создано',
      active: 'Активно',
      addCondition: '1. Добавление условия',
      addMappings: '2. Добавление маппингов',
      addConditionBtn: 'Добавить условие',
      addMappingBtn: 'Добавить маппинг',
      addConditionWarn:
        'Если не добавить условие, правило будет применено для всех клиентов мерчанта.',
      commissionType: 'Тип',
      commissionStatus: 'Статус',
    },
    orderConversion: {
      orderConversion: 'Мониторинг конверсии заказов',
      orderConversionListOrdersTitle: 'Сводка по статусам заказов',
      orderConversionMetricDescription:
        'Конверсия заказов — это метрика, отражающая процентное соотношение заказов, находящихся в состоянии «выполнен», «ожидание» или «отклонен» за выбранный период времени.',
      filterSelectMerchantToViewStats:
        'Пожалуйста, выберите мерчанта в фильтрации для отображения статистики',
      hours1: '1 час',
      hours4: '4 часа',
      hours8: '8 часов',
      hours12: '12 часов',
      minutes60: '60 минут',
      hours3: '3 часа',
      hours5: '5 часов',
      hours7: '7 часов',
      conversion: 'Конверсия',
      thresholds: 'Пороговые значения',
      overallConversionForSelectedGateways:
        'Значение общей конверсии по всем выбранным шлюзам в фильтре.',
      autoupdate: 'Автообновление',
      gatewayConverionSuccessAlert:
        'Конверсия заказов по отдельным шлюзам сформирована за период: %{period}',
      orderConverionSuccessAlert: 'Общая конверсия по заказам сформирована за период: %{period}',
      countLabels: {
        orderCount: 'Всего заказов',
        created: 'Создан',
        pending: 'Ожидание',
        success: 'Успех',
        failure: 'Провал',
        cancelled: 'Отменен',
        expired: 'Просрочен',
        refund: 'Рефанд',
        chargeback: 'Чарджбек',
        prepared: 'Подготовлен',
      },
      showDeviationsOnly: 'Показывать только отклонения',
      gatewaysList: 'Список шлюзов',
      enableAutoupdate: 'Включить автоматическое обновление',
      enableAutoUpdateDescription:
        'При включенном автоматическом обновлении, данные по мониторингу конверсии будут обновляться в фоновом режиме за последние',
      disableAutoupdate: 'Выключить автоматическое обновление',
      disableAutoupdateDescription:
        'Автоматическое обновление данных мониторинга будет приостановлено.',
      editThresholds: 'Пороговые значения',
      addThresholds: 'Пороговые значения',
      deviations: 'Отклонения',
      gatewayNotifications: 'Уведомление для шлюза',
      enableGatewayNotifications: 'Включить уведомления для шлюза',
      enableGatewayNotificationsInfo:
        'Отправка уведомлений для шлюза %{id} %{gateway} будет выполняться в соответствии с настройками уведомлений для мерчанта %{merchant}',
      disableGatewayNotifications: 'Выключить уведомления для шлюза',
      disableGatewayNotificationsInfo:
        'Отправка уведомлений по шлюзу  %{id} %{gateway} для %{merchant} будет отключена после подтверждения.',
      createThresholdSettingsForMonitoring: 'Создание настроек по пороговым значениям',
      editThresholdSettingsForMonitoring: 'Изменение настроек по пороговым значениям',
      maxAllowedDeviationFromAvg14DaysDescription:
        'В соответствии с установленными пороговыми значениями, будет определяться максимально-допустимое отклонение от средних показателей рассчитанных за 14 дней по конкретному шлюзу.',
      setupGuide: 'Справка по настройке',
      settingsCreatedSuccessfully: 'Настройки успешно созданы',
      settingsUpdatedSuccessfully: 'Настройки успешно отредактированы',
      settingsDeletedSuccessfully: 'Настройки успешно удалены',
      notificationsUpdatedSuccessfully: 'Уведомления успешно отредактированы',
      minimumNumberOfOrders: 'Минимальное кол-во заказов',
      minimumHourlyOrderThresholdReddyNotifications:
        'Минимальный порог количества заказов за час для отправки уведомлений в reddy при регистрации событий по отклонениям',
      successfulOrdersDeviationPercentage: 'Процент отклонения по успешным заказам (%)',
      orderConversionBelowAveragePercentagePoints:
        'Укажите на сколько единиц, в процентном соотношении, конверсия по заказам может быть ниже среднестатистического значения',
      cancelledOrdersDeviationPercentage: 'Процент отклонения по отмененным заказам (%)',
      conversionBelowAvgPctPoints:
        'Укажите на сколько единиц, в процентном соотношении, конверсия по заказам может быть выше среднестатистического значения',
      queueOrdersDeviationPercentage: 'Процент отклонения по заказам в очереди (%)',
      conversionAboveAvgPctPointsDesc:
        'Укажите на сколько единиц, в процентном соотношении, конверсия по заказам может быть выше среднестатистического значения',
      enableGatewayNotificationsOnDeviation:
        'Включить оповещения для шлюза, при отклонении от установленных пороговых значениях',
      referenceDialog: {
        monitoringTitle: 'Как работает мониторинг конверсии заказов',
        monitoringDescription:
          'Система каждые пять минут проверяет состояние заказов для активных шлюзов у мерчантов, используя данные за последний час. Она анализирует не только текущие заказы, но и заказы за предыдущие периоды, формируя на основе этих данных средний процент конверсии.',
        monitoringValues:
          'Таким образом, при каждой проверке мы получаем два значения: фактическое и среднее за прошлые периоды. При настройке порогов указываются допустимые отклонения между фактическими данными и средним значением.',
        thresholdsTitle: 'Как настроить пороговые значения',
        successfulOrdersDeviation: 'Процент отклонения по успешным заказам:',
        successfulOrdersDesc:
          'определяет, на сколько процентов фактическое количество успешных заказов может быть ниже среднего.',
        positiveStatus: 'Положительный',
        positiveDesc: 'фактическое выше среднего значения;',
        acceptableStatus: 'Допустимый',
        acceptableDesc: 'фактическое ниже среднего значения, но в рамках допустимых отклонений;',
        deviationStatus: 'Отклонение',
        deviationDesc: 'фактическое ниже среднего и отклонение больше допустимого значения.',
        cancelledOrdersDeviation: 'Процент отклонения по отмененным заказам:',
        cancelledOrdersDesc:
          'определяет, на сколько процентов фактическое количество отмененных заказов может быть выше среднего.',
        queuedOrdersDeviation: 'Процент отклонения по заказам в очереди:',
        queuedOrdersDesc:
          'определяет, на сколько процентов фактическое количество заказов в промежуточных статусах может превышать среднее значение.',
        importantNote: 'Важно учитывать,',
        thresholdsSensitivity:
          'что настройка порогов может быть очень чувствительной для шлюзов с малым количеством заказов и менее критичной для шлюзов с большим количеством. Это важно учитывать при настройках, так как высокие или низкие значения, например 10% или 90%, могут привести к большому числу уведомлений.',
      },
    },
    orderConversionCharts: {
      orderGraphs: 'График заказов по провайдерам',
      ordersForPeriod: 'События за период:',
      orderRatio: 'Соотношение заказов',
      byProvidersForPeriod: 'по провайдерам за период',
      totalOrders: 'Общее количество:',
      status: {
        successful: 'Успешные',
        pending: 'В ожидании',
        failed: 'Провал',
      },
    },
    orderProviderExternalErrors: {
      declineReasonAnalysis: 'Анализ причин отказа',
      declineEvents: 'события отказа',
      totalCount: 'Общее количество:',
      declineRatio: 'Соотношение отказов',
      byProvidersForPeriod: 'по провайдерам за период',
      totalOrders: 'Все заказы',
      declines: 'Отказы',
      summaryForThePeriod: 'сводка за период',
      declineEventsForPeriod: 'События отказа за период:',
      datagrid: {
        eventId: 'ID события',
        createdAt: 'Дата и время события',
        orderId: 'ID заказа',
        category: 'Категория',
        critical: 'Критичная?',
        declineCode: 'Код отказа',
        declineReason: 'Причина отказа',
        numberOfOrdersWithReason: 'Кол-во заказов в системе с данной причиной',
        percentOfDeclinesForSelectedPeriod: '% отказов за выбранный период',
        numberOfDeclines: 'Кол-во отказов за период',
        percentOfDeclines: '% отказов за период',
        declineReasonsByGateway: 'Причины отказа по шлюзу',
      },
      summaryDeclineReasonsForGateway:
        'Сводка причин отказа по шлюзу %{gatewayName} за период %{reportPeriod}',
      summaryDeclineReasonsByGateways: 'Сводка причин отказа по шлюзам за период %{reportPeriod}',
      summaryDeclineReasonsByGatewaysDescription:
        'За период %{reportPeriod} в системе зарегистрированы заказы с причинами отказа по следующим шлюзам:',
      details: 'Подробнее',
    },
    orderMethods: {
      titleText: 'Проверка правил и методов',
      methodName: 'Название метода',
      methodType: 'Тип метода',
      rules: 'Правила',
      amountRequest: 'Запрос суммы',
      depositsNumber: 'Количество депозитов',
      clientId: 'ID клиента',
      appVersion: 'Версия приложения',
      domain: 'Домен',
      infoAlert: 'Для запуска проверки заполните необходимые параметры в фильтре',
      rulesDialog: {
        title: 'История подбора метода',
        updatedAt: 'Дата изменения',
        ruleName: 'Название правила',
        useInTest: 'Используется при проверке',
      },
    },
    notificationPopper: {
      allChecked: 'Все уведомления отмечены как прочитанные',
      checkAll: 'Отметить все как прочитанные',
      download: 'Скачать',
      orderAmountAdjustmentReady:
        'Запрос для массовой корректировки заказов с типом "Корректировка суммы заказа" успешно завершен.',
      orderAmountAdjustmentStart:
        'Запрос для массовой корректировки заказов с типом "Корректировка суммы заказа" успешно подготовлен к обработке.',
      noNotifications: 'Пока нет уведомлений.',
      ordersAdjustmentReport: 'Отчёт по корректировке заказов',
      taskTitle:
        'Для мерчанта %{merchant} по провайдеру %{provider} выполнено задание на пересчет комиссии. Перейти к просмотру',
      commission: 'комиссии',
      notificationStatuses: {
        done: 'готов для скачивания',
        downloaded: 'скачан',
        failure: 'ошибка при формировании',
      },
      reportNames: {
        cumulative: 'Отчёт по нарастающему итогу',
        transactions: 'Отчёт по исполненным транзакциям',
        orders: 'Отчёт по заказам',
        balance: 'Отчёт по балансам',
        ordersAdjustment: 'Отчёт по корректировкам заказов',
        refundChargeback: 'Отчёт по рефандам и чарджбекам',
        expenseReport: 'Отчёт по расходам',
        bankOperationPendingStatuses: 'Отчёт по заявкам на банковские операции',
        bankOperationFinalStatuses: 'Отчёт по банковским операциям',
        importApproveExport: 'Отчёт о некорректных строках файла',
        importRejectExport: 'Отчёт с результатами проверки файла',
      },
      reportDescriptions: {
        importApproveExport:
          'Выполняется загрузка заявок на банковские операции. Будут созданы только корректные заявки на БО. Отчёт об ошибках доступен для скачивания.',
        importRejectExport:
          'Вы отменили загрузку заявок на банковские операции. Для вас сформирован отчёт с результатами проверки файла. Исправьте ошибки и повторите попытку.',
      },
    },
    navMenu: {
      finance: {
        title: 'Финансы',
        balanceReport: 'Отчёт о балансах',
        cumulativeReport: 'Отчёт по нарастающему итогу',
        ordersReport: 'Отчёт по транзакциям',
        refundChargebackReport: 'Отчёт по рефандам и чарджбекам',
        expenseReport: 'Отчёт по расходам',
        commissions: 'Комиссии',
        bankOperations: 'Заявки на банковские операции',
        bankOperationsFinalStatuses: 'Банковские операции',
        workTeams: 'Рабочие группы',
        providerAccounts: 'Настройки доступов',
        commissionRecalculationTasks: 'Задания на перерасчёт комиссий',
        reconciliation: 'Автосверка',
      },
      users: {
        title: 'Пользователи',
        users: 'Пользователи системы',
        roles: 'Роли',
        userActions: 'Пользовательские действия',
      },
      directories: {
        title: 'Справочники',
        companies: 'Компании',
        referrals: 'Рефералы',
      },
      companies: {
        title: 'Компании',
      },
      apiClients: {
        title: 'Клиенты API',
      },
      merchants: {
        title: 'Мерчанты',
      },
      dashboard: {
        title: 'Дашборд',
      },
      monitoring: {
        title: 'Мониторинг',
        orderConversion: 'Конверсии заказов',
        orderConversionChart: 'График заказов по провайдерам',
        orderProviderExternalErrors: 'Анализ причин отказа',
        monitoringSettings: 'Настройки',
      },
      gatewayRules: {
        title: 'Правила',
        gatewayRules: 'Правила',
        orderMethods: 'Проверка правил и методов',
      },
      orders: {
        title: 'Заказы',
        orders: 'Заказы',
        orderAdjustments: 'Массовая корректировка',
        orderAdjustmentsReport: 'Отчёт по корректировкам',
        orderManualCreate: 'Ручное создание заказа',
        bulkUpdate: 'Изменение статусов заказов',
      },
      methods: {
        title: 'Методы',
        methods: 'Методы',
        methodLogos: 'Логотипы методов',
      },
      gateways: {
        title: 'Шлюзы',
        gateways: 'Шлюзы',
        limits: 'Лимиты',
        gatewayDeactivationReasons: 'Причины деактивации шлюза',
      },
      providers: {
        title: 'Провайдеры',
      },
      presets: {
        title: 'Пресеты',
      },
    },
    datePicker: {
      dateTimeRangeSelection: 'Выберите диапазон дат и время',
      dateRangeSelection: 'Выберите диапазон дат',
      rangeStart: 'Начало',
      rangeEnd: 'Конец',
      timezone: 'Часовой пояс',
      timeFrom: 'Время начала',
      timeTo: 'Время конца',
      time: 'Время',
      shortcuts: {
        today: 'Сегодня',
        yesterday: 'Вчера',
        lastWeek: 'Последняя неделя',
        currentWeek: 'Текущая неделя',
        lastMonth: 'Последний месяц',
        currentMonth: 'Текущий месяц',
        last24Hours: 'Последние 24 часа',
        last7Days: 'Последние 7 дней',
        last30Days: 'Последние 30 дней',
      },
    },
    methods: {
      details: 'Просмотр метода',
      type: 'Тип метода',
      active: 'Активен',
      inactive: 'Неактивен',
    },
    dashboard: {
      title: 'Дашборд',
      noResultsAlert:
        'Нет результатов. Чтобы сформировать виджеты, задайте новые параметры в фильтре.',
      timeRangeAlert: 'Данные отображаются за последние 24 часа: %{timeRange}',
      transactionsSummary: {
        title: 'Транзакций за период',
        deposits: 'Пополнения',
        withdrawals: 'Выводы',
      },
      successfulTransactionsSummary: {
        title: 'Успешность транзакций за период',
        total: 'Всего транзакций',
        successful: 'Успешные',
        refused: 'Отказанные',
        pending: 'Ожидание',
      },
      transactionsDynamicSummary: {
        title: 'Динамика суммы исполненных транзакций за период',
        deposits: 'Пополнения',
        withdrawals: 'Выводы',
        currency: 'Валюта конвертации: %{currency}',
      },
      entitiesSummary: {
        merchant: 'Мерчант',
        provider: 'Провайдер',
        merchantsCardTitle: 'Топ мерчантов',
        providersCardTitle: 'Топ провайдеров',
        cardDescription: 'По количеству успешных транзакций',
        totalTransactions: 'Всего заказов',
        successfulTransactions: 'Успешные заказы (конверсия)',
      },
    },
    referrals: {
      title: 'Рефералы',
      emptyAlert: 'Нет добавленных рефералов. Чтобы добавить реферал, нажмите «Добавить».',
      refId: 'ID реферала',
      deleteTitle: 'Удаление реферала',
      deleteDetails: 'После удаления реферал %{name} будет недоступен для восстановления.',
      showTitle: 'Просмотр реферала',
      createTitle: 'Создание реферала',
      editTitle: 'Редактирование реферала',
    },
  },
};
